<template>
  <div class="homepage-hero-module">
    <div class="video-container">
      <!--  poster="http://gccs-test-public-read.oss-cn-beijing.aliyuncs.com/fbb6a886-1df0-4148-85c8-c5a071b187d7?x-oss-process=image/resize,w_1920" -->
      <video id="homePageVideo" :style="videoStyle" autoplay loop muted class="fillWidth" :poster="poster" v-on:canplay="canplay">
        <source src="https://zjy-gccs-test.oss-cn-beijing.aliyuncs.com/08d52590-c1f4-4775-b84c-00a3073d7f84?x-oss-process=video"/>
        浏览器不支持 video 标签，建议升级浏览器。
      </video>
    </div>
  </div>
</template>
<style scoped>
  .homepage-hero-module,
  .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .video-container .poster img,
  .video-container video {
    position: absolute;
    margin: 0 auto;
    height: auto;
    left: 0;
    /*bottom: 0;*/
    width: 100%;
  }
</style>

<script>
const poster = require('assets/images/indexpage/index/poster.png')
export default {
  name: 'BackgroundVideo',
  data () {
    return {
      vedioCanPlay: false,
      videoStyle: '',
      poster
    }
  },
  methods: {
    canplay () {
      this.vedioCanPlay = true
    },
    computeVideoSize () {
      const w = 960 // 视频源 宽高比 960 / 540 = 16 : 9
      const h = 540
      const winW = document.body.clientWidth || document.documentElement.clientWidth
      const winH = document.body.clientHeight || document.documentElement.clientHeight
      let videoStyle = ''
      let newW = 1
      let newH = 1
      if (winW && winH) {
        if ((winW / winH) >= (w / h)) {
          // 窗口宽高比 大于视屏源文件 宽高比 按照 宽度 放大(缩小)视频
          newW = winW // 视频放大(缩小)后的宽度
          newH = (newW * 540) / 960 // 视频放大(缩小)后的高度
          const marginTop = -((newH - winH) / 2) // 视频放大(缩小)后 向顶部的偏移
          videoStyle = 'margin-top: ' + marginTop + 'px; '
        } else {
          // 按照 高度 放大(缩小)视频
          newH = winH // 视频放大(缩小)后的高度
          newW = (960 * newH) / 540 // 视频放大(缩小)后的宽度
          const marginLeft = -((newW - winW) / 2) // 视频放大(缩小)后 向顶部的偏移
          videoStyle = 'margin-left: ' + marginLeft + 'px; '
        }
        videoStyle += 'width: ' + newW + 'px; ' + 'height: ' + newH + 'px; visibility: visible; '
        if (newW > 1 && newW > 1) {
          this.videoStyle = videoStyle
        }
      }
    },
    // 判断视频是否能播放了
    judgeCanplay () {
      this.$nextTick(() => {
        const nowVideo = document.getElementById('homePageVideo')
        if (nowVideo) {
          nowVideo.oncanplay = () => {
            console.log('video canplay')
            this.poster = ''
            nowVideo.play()
            nowVideo.volume = 0.2
          }
        }
      })
    }
  },
  mounted () {
    this.computeVideoSize()
    this.resizeHandle.resize(() => {
      this.computeVideoSize()
    })
    this.judgeCanplay()
    //  window.onresize = () => {
    //   const windowWidth = document.body.clientWidth
    //   const windowHeight = document.body.clientHeight
    //   const windowAspectRatio = windowHeight / windowWidth
    //   this.videoStyle = {
    //     transform: rotateY(`41.41deg`)
    //   }
    // }
    // window.onresize()
  }
}
</script>
